<template>
  <section class="radio-group-demo">
    <radio-group v-model="model_value"
                 group-name="foo"
                 :options="radio_options"
                 :flex-direction="flex_direction"
                 @change="logChange" />
    <div id="v-model" ref="v_model" class="text-center">
      v-model: {{ model_value }}
    </div>
    <div class="selection-log">
      <label for="selection-log">Change log:</label>
      <pre id="selection-log" ref="selection_log" />
    </div>
    <div class="direction-select">
      <label for="direction-select">
        Layout direction:
      </label>
      <multiselect id="direction-select"
                   v-model="flex_direction"
                   :options="allowed_directions"
                   :show-selected="false"
                   select-label=""
                   class="direction-select-ms" />
    </div>
  </section>
</template>

<script>
import RadioGroup from 'VueComponents/RadioGroup';

export default {
  components: {
    RadioGroup,
  },
  data: () => ({
    model_value: null,
    flex_direction: "row",
    allowed_directions: [
      "row",
      "column",
      "row-reverse",
      "column-reverse",
    ],
    radio_options: [
      {
        display: "Option A",
        value: 0,
      },
      {
        display: "Maybe option B?",
        value: 100,
      },
      {
        display: "Option three",
        value: "apples",
        checked: true,
      },
    ],
  }),
  watch: {
    model_value(checked, previous) {
      if (this.$refs["selection_log"] && previous) {
        const log_line = `v-model change: ${previous.display} (${previous.value}) -> ${checked.display} (${checked.value})`;
        this.$refs["selection_log"].innerHTML = `${this.$refs["selection_log"].innerHTML}\n${log_line}`;
      }
    },
  },
  methods: {
    logChange(ev) {
      if (this.$refs["selection_log"]) {
        const log_line = `Change event: { display: ${ev.display}, value: ${ev.value}, checked: ${ev.checked ?? 'false'} }`;
        this.$refs["selection_log"].innerHTML = `${this.$refs["selection_log"].innerHTML}\n${log_line}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~AssetsSass/_variables" as *;

%align-col-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.radio-group-demo {
  @extend %align-col-center;
  width: 100%;

  .direction-select {
    margin-top: 1em;
    @extend %align-col-center;

    label {
      font-size: 1.2em;
      font-weight: bolder;
    }

    .direction-select-ms {
      width: 12em;
      margin: 0.2em 0 0.75em 0;
    }
  }

  #v-model {
    font-weight: bolder;
    font-size: 2em;
    margin: 1em 0 0.5em 0;
  }

  .selection-log {
    @extend %align-col-center;
    width: 100%;

    #selection-log {
      width: 60%;
      height: 16em;
      overflow: auto;
      background-color: white;
      border: 1px solid map.get($ss-adds, 'border-gray');
      border-radius: 3px;
      padding: 1em;
    }
  }
}
</style>
